import { jwtDecode } from "jwt-decode";

const useCheckHesToken = () => {

    const token: string | null = localStorage.getItem('hes_token');
    if(!token) return false;
    
    const decodedToken: { exp: number } = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
}

export default useCheckHesToken;